/**
 * CR383: Recipe select for S0.5 FLYER_FETCH recipes
 */

import { useState, useEffect } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { supabase } from "@/integrations/supabase/client";

interface RecipeOption {
  id: string;
  recipe_name: string;
  description: string | null;
}

interface S05RecipeSelectProps {
  value: string | null;
  onChange: (id: string | null) => void;
}

export function S05RecipeSelect({ value, onChange }: S05RecipeSelectProps) {
  const [recipes, setRecipes] = useState<RecipeOption[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      const { data, error } = await supabase
        .from("capture_recipe_templates")
        .select("id, recipe_name, description")
        .eq("recipe_scope", "FLYER_FETCH")
        .eq("is_archived", false)
        .order("recipe_name");

      if (!error && data) {
        setRecipes(data as RecipeOption[]);
      }
      setLoading(false);
    };
    fetch();
  }, []);

  return (
    <Select
      value={value ?? "__none__"}
      onValueChange={(v) => onChange(v === "__none__" ? null : v)}
    >
      <SelectTrigger>
        <SelectValue placeholder={loading ? "Loading…" : "No recipe"} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="__none__">No recipe (default)</SelectItem>
        {recipes.map((r) => (
          <SelectItem key={r.id} value={r.id}>
            {r.recipe_name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
